import Vue from 'vue';
import VueRouter from 'vue-router';
//index
const main = () => import('@/views/main/main');
// 404
const NotFound = () => import(/* webpackChunkName: "404" */ '@/views/404/index');
const live = () => import(/* webpackChunkName: "404" */ '@/views/live/edit');
//商品编辑
const goodsEdit = () => import(/* webpackChunkName: "404" */ '@/views/goods/edit');

//拍品编辑
const lotEdit = () => import(/* webpackChunkName: "404" */ '@/views/auction/edit');
//资产管理
const capitalIndex = () => import('@/views/capital/index');
//收款账户
const capitalAccount = () => import('@/views/capital/account');
//开通收款账户
const capitalOpen = () => import('@/views/capital/open');
//提现记录
const capitalRecord = () => import('@/views/capital/record');
//提现
const capitalWithdrawal = () => import('@/views/capital/withdrawal');
//企业开通收款账户
const capitalEnterprise = () => import('@/views/capital/enterprise');
//开通状态页
const capitalExamine = () => import('@/views/capital/examine');
Vue.use(VueRouter);
const routes = [
  {
    path: '/404',
    meta: { title: '' },
    component: NotFound,
  },
  {
    path: '/',
    meta: { title: '首页' },
    component: main,
    children: [
      {
        path: '',
        name: 'index',
        component: () => import('@/views/main/index'),
        meta: { title: '首页' },
      },
    ],
  },
  {
    path: '/index',
    meta: { title: '首页' },
    component: main,
    children: [
      {
        path: '',
        name: 'index',
        component: () => import('@/views/main/index'),
        meta: { title: '首页' },
      },
    ],
  },
  {
    path: '/other',
    meta: { title: '其余功能' },
    component: main,
    children: [
      {
        path: '',
        name: 'other',
        component: () => import('@/views/main/other'),
        meta: { title: '其余功能' },
      },
    ],
  },
  {
    path: '/personal',
    meta: { title: '我的' },
    component: main,
    children: [
      {
        path: '',
        name: 'personal',
        component: () => import('@/views/main/personal'),
        meta: { title: '我的' },
      },
    ],
  },
  {
    path: '/capital/index',
    meta: { title: '资产管理' },
    component: capitalIndex,
  },
  {
    path: '/capital/account',
    meta: { title: '收款账户' },
    component: capitalAccount,
  },
  {
    path: '/capital/open',
    meta: { title: '开通收款账户' },
    component: capitalOpen,
  },
  {
    path: '/capital/record',
    meta: { title: '提现记录' },
    component: capitalRecord,
  },
  {
    path: '/capital/withdrawal',
    meta: { title: '提现' },
    component: capitalWithdrawal,
  },
  {
    path: '/capital/gift',
    meta: { title: '礼物记录' },
    component: () => import('@/views/capital/gift'),
  },
  {
  path: '/capital/enterprise/:id',
  meta: { title: '开通收款账户' },
  component: capitalEnterprise,
},
{
  path: '/capital/examine/:id',
  meta: { title: '开通收款账户' },
  component: capitalExamine,
},
  {
    path: '/live',
    meta: { title: '创建直播' },
    component: live,
  },

  {
    path: '/live/list',
    meta: { title: '直播列表' },
    component: () => import('@/views/live/list'),
  },
  {
    path: '/live/:id',
    meta: { title: '编辑直播' },
    component: live,
  },
  {
    path: '/rela/goodsList',
    meta: { title: '关联商品列表' },
    component: () => import('@/views/rela/goodsList'),
  },
  {
    path: '/rela/goodsList/:id',
    meta: { title: '关联商品列表' },
    component: () => import('@/views/rela/goodsList'),
  },
  {
    path: '/rela/artWork',
    meta: { title: '关联作品列表' },
    component: () => import('@/views/rela/artWorkList'),
  },
  {
    path: '/rela/artWork/:id',
    meta: { title: '关联作品列表' },
    component: () => import('@/views/rela/artWorkList'),
  },
  {
    path: '/rela/aucArtwork',
    meta: { title: '关联拍品列表' },
    component: () => import('@/views/rela/acuArtworkList'),
  },
  {
    path: '/rela/aucArtwork/:id',
    meta: { title: '关联拍品列表' },
    component: () => import('@/views/rela/acuArtworkList'),
  },
  {
    path: '/goods/list',
    meta: { title: '商品列表' },
    component: () => import('@/views/goods/list'),
  },
  {
    path: '/auction/list',
    meta: { title: '拍品列表' },
    component: () => import('@/views/auction/list'),
  },
  
  {
    path: '/goods/add',
    meta: { title: '创建商品' },
    component: goodsEdit,
  },
  {
    path: '/goods/:id',
    meta: { title: '编辑商品' },
    component: goodsEdit,
  },
  {
    path: '/auction/add',
    meta: { title: '创建拍品' },
    component: lotEdit,
  },
  {
    path: '/auction/:id',
    meta: { title: '编辑拍品' },
    component: lotEdit,
  },
  {
    path: '/auction/live/add/',
    meta: { title: '创建拍品' },
    component: lotEdit,
  },
  {
    path: '/help/index',
    meta: { title: '帮助中心' },
    component: () => import('@/views/help/index'),
  },
];

const orderRouters = [
  {
    path: '/order/good/list',
    meta: { title: '订单列表' },
    component: () => import('@/views/order/good/list'),
  },
  {
    path: '/order/good/detail/:id',
    meta: { title: '订单详情' },
    component: () => import('@/views/order/good/detail'),
  },
  {
    path: '/order/auction/list',
    meta: { title: '订单列表' },
    component: () => import('@/views/order/auction/list'),
  },
  {
    path: '/order/auction/detail/:id',
    meta: { title: '订单详情' },
    component: () => import('@/views/order/auction/detail'),
  },
  {
    path: '/order/margin/list',
    meta: { title: '保证金列表' },
    component: () => import('@/views/order/margin/list'),
  },
  {
    path: '/order/margin/detail/:id',
    meta: { title: '保证金详情' },
    component: () => import('@/views/order/margin/detail'),
  },
];
const router = new VueRouter({
  routes: [...routes, ...orderRouters],
});

export default router;
